/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import UploadedFileBlock from 'bundles/assess-common/components/UploadedFileBlock';
import type { EmbeddedContentProps } from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedContent';

const styles = {
  container: css`
    margin: var(--cds-spacing-100) 0;
  `,
};

export const EmbeddedLink: React.FC<EmbeddedContentProps> = ({ url, title }: EmbeddedContentProps) => {
  return (
    <div css={styles.container} data-testid="embedded-link">
      <UploadedFileBlock fileUrl={url} filename={title} disabled />
    </div>
  );
};

export default EmbeddedLink;
